import { takeLatest, call, put } from 'redux-saga/effects';

import { fetchProcesses } from 'modules/processes/data/sagas';

import supplierSettingsService from 'services/supplierSettingsService';

import { fieldSettingsFetch, fieldSettingsUpdate } from './actions';
import { types } from './actions';

export default function* root() {
  yield takeLatest(
    types.FIELD_SETTINGS_FETCH_REQUEST,
    watchFetchRfqFieldSettings,
  );
  yield takeLatest(
    types.FIELD_SETTINGS_UPDATE_REQUEST,
    watchFieldSettingsUpdateRequest,
  );
}

export function* watchFetchRfqFieldSettings() {
  try {
    const {
      defaultProcessId,
      showProcessSelector,
      showMaterialSelector,
      showFinishSelector,
      showDeliveryDateSelector,
      showNotesField,
      showReferralField,
      showRfqNumberField,
      showContactAddressFields,
    } = yield call(supplierSettingsService.getRfqSettings);
    yield put(
      fieldSettingsFetch.success({
        defaultProcessId,
        showProcessSelector,
        showMaterialSelector,
        showFinishSelector,
        showDeliveryDateSelector,
        showNotesField,
        showReferralField,
        showRfqNumberField,
        showContactAddressFields,
      }),
    );
  } catch (err) {
    yield put(fieldSettingsFetch.error(err));
  }
}

function* watchFieldSettingsUpdateRequest(action) {
  try {
    const updatedFields = action.payload;
    const {
      defaultProcessId,
      showProcessSelector,
      showMaterialSelector,
      showFinishSelector,
      showDeliveryDateSelector,
      showNotesField,
      showReferralField,
      showRfqNumberField,
      showContactAddressFields,
    } = yield call(supplierSettingsService.updateRfqSettings, updatedFields);
    yield put(
      fieldSettingsUpdate.success({
        defaultProcessId,
        showProcessSelector,
        showMaterialSelector,
        showFinishSelector,
        showDeliveryDateSelector,
        showNotesField,
        showReferralField,
        showRfqNumberField,
        showContactAddressFields,
      }),
    );
  } catch (err) {
    yield put(fieldSettingsUpdate.error(err));
  }
}

export function* initSaga() {
  yield call(watchFetchRfqFieldSettings);
  yield call(fetchProcesses);
}
